<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from "vue";
import { type PopupButton } from '@tma.js/sdk-vue'
import router from "@/router";
import { useStore } from "vuex";
import {useRoute} from "vue-router";
import { setHaptic } from "@/tools/setTelegramHaptick";
import { setBackButton, hideBackButton, setBottomButton, hideBottomButton, setBottomSecondaryButton, hideBottomSecondaryButton } from '@/tools/setTelegramButtons';
import { getOrderById, editOrderStatus, getStatisticByOrder, editOrderById, deleteOrderById } from '@/composables/orderWorkerk';
import SatisticItems from "@/components/mobile/telegram/settings_components/setting_list/SatisticItems.vue";
import { createPopupManager } from '@/tools/setTelegramPopUp'
import Order from '@/models/order';
import OrderViewItem from "@/components/mobile/telegram/order_components/OrderViewItem.vue";
import Point from "@/models/point";
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';
import { formatedDateDay } from '@/tools/tools'

const point_uuid = ref();
const point_id = ref();
const id = ref();
const isAdmin = ref();
const statData = ref();
const store = useStore();
const editOrder = ref(false);
const order = ref<Order | null >(null); 
let mainButtonListener: (() => void) | null = null;
const popupManager = createPopupManager();
const points = ref<Point[]>(store.getters.getAllPoints);
const respIsResieved = ref<boolean>(false);
const respStatIsResieved = ref<boolean>(false);

const currentPoint = computed(() => {
  return points.value.find((point: Point) => point.id === point_id.value) ?? null
})

const handleMainButton = async () => {
  console.log('Нажата основная кнопка');
  setHaptic();

  if (editOrder.value === true) {
    editOrder.value = false;
    edtitOrder();
    return;
  }

  if (order.value?.status == 'Новый' && (store.getters.USER.role == 'warehouse' || store.getters.USER.role == 'admin' || store.getters.USER.role == 'warehouse_driver' || store.getters.USER.role == 'warehouse_driver_loader')) {
    await editOrderStatusById('В сборке');
    return;
  }
  else if(order.value?.status == 'В сборке' && (store.getters.USER.role == 'warehouse' || store.getters.USER.role == 'admin' || store.getters.USER.role == 'warehouse_driver' || store.getters.USER.role == 'warehouse_driver_loader')) {
    //Старая логика со сканером
    // router.push(`/order_scan_component?point_id=${point_id.value}&order_id=${id.value}&context=warehouse`);
    router.push(`/order_collect_component?point_id=${point_id.value}&order_id=${id.value}&context=warehouse`);
    return;
  }
  else if(order.value?.status == 'Собран' && (store.getters.USER.role == 'driver' || store.getters.USER.role == 'admin' || store.getters.USER.role == 'warehouse_driver' || store.getters.USER.role == 'warehouse_driver_loader')) {
    await editOrderStatusById('В пути');
    return;
  }
  else if(order.value?.status == 'В пути' && (store.getters.USER.role == 'loader' || store.getters.USER.role == 'admin' || store.getters.USER.role == 'warehouse_driver' || store.getters.USER.role == 'warehouse_driver_loader')) {
    //Старая логика со сканером
    // router.push(`/order_scan_component?point_id=${point_id.value}&order_id=${id.value}&context=point`);
    router.push(`/order_collect_component?point_id=${point_id.value}&order_id=${id.value}&context=point`);
    return;
  }
  else {
    router.push('/')
  }

};

function routerPush() {
  router.push('/')
}


onMounted(async() => {
  setBackButton();
  //id заказа
  id.value = Number(useRoute().query.id);
  //id точки
  point_id.value = Number(useRoute().query.point_id);
  //uuid точки
  point_uuid.value = useRoute().query.point_uuid;
  //параметр для отображения статистики
  isAdmin.value = useRoute().query.isAdmin?.toString();

  console.log('isAdmin.value=', isAdmin.value)

  if (isAdmin.value == 'true') {
    await getStatByOrderId(id.value);
  }
  
  if(id.value) {
    await getOrder(point_id.value, id.value);
  }
})

onUnmounted(() => {
  hideBackButton();
  hideBottomButton();
  hideBottomSecondaryButton(); 
});

//Получение конкретного заказа по id
async function getOrder(point_id: number, order_id: number) {
  order.value = await getOrderById(point_id, order_id);
  if (!order.value) {
    popupManager.openPopup(`Такой заказ не найден`,
      (buttonId) => {
        console.log("Нажата кнопка:", buttonId);
        if (buttonId === 'cancel') {
          router.push('/')
          popupManager.cleanup();
        }
      },
    );
    return null;
  }
  respIsResieved.value = true;
  checkAndSetBtn();
}

const STATUS_CONFIG = {
  'Новый': {
    roles: ['warehouse', 'admin', 'warehouse_driver', 'warehouse_driver_loader'],
    label: 'В сборке',
  },
  'В сборке': {
    roles: ['warehouse', 'admin', 'warehouse_driver', 'warehouse_driver_loader'],
    // label: 'Сканировать товары',
    label: 'Собрать товары',
  },
  'Собран': {
    roles: ['driver', 'admin', 'warehouse_driver', 'warehouse_driver_loader'],
    label: 'Забрал заказ',
  },
  'В пути': {
    roles: ['loader', 'admin', 'warehouse_driver_loader'],
    label: 'Разгружаю',
  },  
};

function checkAndSetBtn() {
  const role = store.getters.USER.role;
  const status = order.value!.status;

  if (!status) {
    mainButtonListener = handleMainButton;
    setBottomButton('На главную', '31B545', 'FFFFFF', handleMainButton);
    return;
  }
  
  if (isAdmin.value === 'true') {
    mainButtonListener = handleMainButton;
    setBottomButton('Назад', '31B545', 'FFFFFF', routerPush);
    return;
  }

  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

  if (config && config.roles.includes(role)) {
    mainButtonListener = handleMainButton;
    setBottomButton(config.label, '31B545', 'FFFFFF', handleMainButton);
  } else {
    mainButtonListener = handleMainButton;
    setBottomButton('На главную', '31B545', 'FFFFFF', handleMainButton);
  }

  if (store.getters.USER.role === 'admin') {
    setBottomSecondaryButton('Удалить заказ', 'E64D44', 'FFFFFF', 'left', handleSecondaryButton);
  }
}

async function handleSecondaryButton() {
  let buttons: PopupButton[];
  buttons = [
    {
      id: 'delete',
      text: 'Удалить',
      type: 'default'
    },
    {
      id: 'cancel',
      type: 'close'
    }
  ];
  popupManager.openPopup(`Вы уверены что хотите удалить заказ №${order.value?.id}?`,
    async (buttonId) => {
      if (buttonId === 'delete') {
        if (order.value?.id) {
          const data = await deleteOrderById(point_id.value, order.value?.id);
          if (data) {
            popupManager.openPopup(data.message, (buttonId) => {
              if (buttonId === 'cancel') {
                router.push('/')
                popupManager.cleanup();
              }
            },)
          }
        } else {
          console.log('Не нашли такой заказ');
          popupManager.cleanup();
        }
      }
    }, buttons
  )
}

//Редактирования заказа
const functEditOrder = () => {
  if (order.value?.status == 'Новый' || order.value?.status == 'В сборке') {
    hideBottomSecondaryButton();
    setBottomButton('Подтвердить', '31B545', 'FFFFFF', handleMainButton)
    editOrder.value = !editOrder.value;
    if (editOrder.value === false) {
      edtitOrder();
    } 
  }
}

function addQuantityProductInOrder(product_id: number) {
  if (!order.value) return;
  
  const targetItem = order.value.products.find(
    (product) => product.product.id === product_id
  );
  
  if (targetItem) {
    targetItem.quantity++;
  }
}

async function delQuantityProductInOrder(product_id: number) {
  if (!order.value) return;
  
  const targetItem = order.value.products.find(
    (product) => product.product.id === product_id
  );
  
  if (targetItem && targetItem.quantity > 0) {
    targetItem.quantity--;
    
    if (targetItem.quantity === 0) {
      removeProductInOrder(product_id);
    }
  }
}

function removeProductInOrder(product_id: number) {
  if (!order.value) return;
  
  order.value.products = order.value.products.filter(
    (product) => product.product.id !== product_id
  );
}

//Форматированные товары в заказе для запроса
const formattedOrderItems = () => {
  return order.value!.products.map((product) => ({
    name: product.product.name,
    quantity: product.quantity,
    containerId: product.product.packaging.id
  }))
}

//Функция редактирования заказа 
async function edtitOrder() {

  hideBottomButton();

  try{
    const formatItmes = formattedOrderItems();
    const params = { order_id: id.value, comment: order.value!.comment, products: formatItmes}
    const result = await editOrderById(point_id.value, params);

    if(result) {
      console.log('Успешно изменили заказ:', result)
      setTimeout(() => {
        popupManager.openPopup(`Успешно изменили заказ`,
          (buttonId) => {
            console.log("Нажата кнопка:", buttonId);
          },
        );
      },100);
      checkAndSetBtn();
    }
  }
  catch(error) {
    hideBottomButton();
    popupManager.openPopup(`Не удалось изменить заказ. Попробуйте ещё раз.`,
      (buttonId) => {
        console.log("Нажата кнопка:", buttonId);
      },
    );
    console.error('Ошибка создания заказа:', error);

  }
}

//Получение статистики по заказу
async function getStatByOrderId(order_id: number | null) {
  statData.value = await getStatisticByOrder(point_id.value, order_id)
  respStatIsResieved.value = true;
}

function noneClick() {
  console.log('click')
}

//Изменить статус заказа
async function editOrderStatusById(status: string){

  setBottomButton('Ждём подтверждения', '31B545', 'FFFFFF', null, false, true);
  const params = {order_id: order.value!.id, status}
  const data = await editOrderStatus(point_id.value, params)
  if (data) {
    setTimeout(() => {
      popupManager.openPopup(`Статус заказа изменён на ${status}`,
        (buttonId) => {
          console.log("Нажата кнопка:", buttonId);
        },
      );
    },100);
    await getOrder(point_id.value, id.value);
  }
}


const editOrderReact = computed(() => {
  if (id.value) {
    if (store.getters.USER.role == 'warehouse' || store.getters.USER.role == 'admin' || store.getters.USER.role == 'warehouse_driver') {
      if (order.value?.status == 'Новый' || order.value?.status == 'В сборке') {
        return true;
      }
      else {
        return false;
      }
    }
    else {
        return false;
      }
  }
  else {
    return false;
  }
});


</script>

<template>
  <div class="order-wrapper">
    <div class="order-header">
      <div class="absolute-status" :style="{ backgroundColor: order?.status == 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)' }"></div>
      <p class="name-point">{{ currentPoint?.name }}</p>
      <p class="name-order">Заказ #{{ id }}</p>
      <p class="name-order">Создан: {{ formatedDateDay(order?.date_create) }}</p>
      <p class="order-status" :style="{ color: order?.status === 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)' }">{{ order?.status }}</p>
    </div>
    <div class="comment-wrapper" v-if="order?.comment && respIsResieved">
      <p class="comment-label">Комментарий</p>
      <p class="comment">{{ order?.comment }}</p>
    </div>
    <AnimatePlaceHolder v-else-if="!respIsResieved"
      width="100%"
      height="129px"
      border-radius="var(--border-radius)"
      style="margin-top: 5px;"
    />
    <SatisticItems v-if="isAdmin && respStatIsResieved"
      :statData="statData"
    />
    <AnimatePlaceHolder v-else-if="isAdmin && !respStatIsResieved"
      width="100%"
      height="129px"
      border-radius="var(--border-radius)"
      style="margin-top: 5px;"
    />
    <div class="order-items" v-if="respIsResieved">
      <OrderViewItem v-for="item in order?.products"
        :item="item"
        :edit-order="editOrder"
        @addQuantityProductInOrder="addQuantityProductInOrder"
        @delQuantityProductInOrder="delQuantityProductInOrder"
        @removeProductInOrder="removeProductInOrder"
      />
      <p v-if="editOrderReact && !editOrder && !isAdmin" class="edit-order" :style="{ color: editOrder ? 'var(--orange-color)' : 'var(--green-color)' }" @click="functEditOrder()">{{ editOrder ? 'Подтвердить' : 'Редактировать' }}</p>
    </div>
    <AnimatePlaceHolder v-else-if="!respIsResieved"
      width="100%"
      height="129px"
      border-radius="var(--border-radius)"
      style="margin-top: 5px;"
    />
  </div>
</template>

<style scoped>

.absolute-status {
  position: absolute;
  width: 5px;
  height: 100%;
  top: 0;
  left: 0;
}

.btn-edit-order{
  margin-top: 30px;
  background-color: var(--orange-color);
  border-radius: var(--border-radius);
  padding: 15px 100px;
  font-weight: 400;
}

.comment {
  font-size: 16px;
  width: 100%;
  text-align: start;
  color: #525252;
  padding: 20px;
  background-color: var(--grey-color);
  border-radius: var(--border-radius-2);
  box-sizing: border-box;
}

.comment-label {
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.comment-wrapper{
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
  border-radius: var(--border-radius);
  margin-top: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 10px;
}

.order-items{
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  padding: 0 10px;
  box-shadow: var(--drop-shadow-item);
  margin-bottom: 10px;
}

.edit-order{
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  margin-top: 1px;
}

.order-status {
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
}

.name-order{
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.name-point {
  font-size: 16px;
  color: #B9B9B9;
  font-weight: 600;
}

.order-header{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 5px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
  overflow: hidden;
}

.order-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

</style>